import { render } from "./Inquiry.vue?vue&type=template&id=585475e5&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=585475e5&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585475e5"]])

export default __exports__